import {Component, Input, OnInit} from '@angular/core';
import * as saveAs from 'file-saver';
import {PermissionsService} from "../../../../services/permissions/permissions.service";
import {PlanService} from "../../../../services/plan-status/plan-status.service";

@Component({
  selector: 'app-referee-file-upload',
  templateUrl: './referee-file-upload.component.pug',
  styleUrls: ['./referee-file-upload.component.scss'],
  standalone: false
})
export class RefereeFileUploadComponent implements OnInit {

  @Input() referee: any;

  constructor(private permissions: PermissionsService, private planservice: PlanService,) { }

  ngOnInit(): void {
    // value.created_date = moment(value.created_date).format('MMM DD, YYYY');
  }

  downloadAttachment() {
    const userdetails = this.permissions.hasxrpUserPermission();
    const metaData = {
      "log":{
        "referee_id": this.referee.id,
        "username": userdetails['username'],
        "message": "User downloaded confirmed referee attachment"
      },
      "audit_log": "DOWNLOAD_CONFIRMED_REFEREE_FILE"
    };
    this.planservice.postLog(metaData);
    saveAs.saveAs(this.referee.uploaded_pdf_url, this.referee.uploaded_pdf_title);
  }

}
